import TagManager from 'react-gtm-module';

// Events RTB House (retargeting). Repris à l'identique du projet nextjs
// (libs/RtbHouse/events.ts). `rtbhUserId` = hash sha256 de l'email du membre.
// Les events sont ré-exploités côté conteneur GTM (GTM-KHM4FXW) par le tag RTB House.

type Member = { emailHash?: string } | null | undefined;

const getRtbhUserId = (member: Member): string => member?.emailHash || '';

/** Statut du panier : liste des productGroup présents au panier. */
export const pushRtbhBasketStatus = (
  productGroupIds: (string | number)[],
  member: Member
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'rtbh_basketstatus',
      rtbhProductIds: productGroupIds.map(String),
      rtbhUserId: getRtbhUserId(member),
    },
  });
};

/** Début de commande : clic sur le bouton « accéder à la livraison ». */
export const pushRtbhStartOrder = (member: Member) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'rtbh_startorder',
      rtbhUserId: getRtbhUserId(member),
    },
  });
};
